var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCapitallyEfficient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4754 23.7969V26.5022C17.2845 28.9543 15.1166 30.8066 12.6078 30.6467C10.099 30.8066 7.91745 28.9543 7.72656 26.5022V23.7969C7.72656 26.089 9.90811 27.7149 12.6078 27.7149C15.3074 27.7149 17.4754 26.0757 17.4754 23.7969V23.7969Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4753 20.1315C17.4753 20.7712 17.2981 21.3976 16.9572 21.944C15.9755 23.3299 14.3257 24.1295 12.5941 24.0495C10.8625 24.1295 9.22634 23.3299 8.23101 21.944C7.89014 21.3976 7.71289 20.7712 7.71289 20.1315C7.72653 18.9988 8.24464 17.9327 9.1309 17.213C10.099 16.4134 11.3124 15.987 12.5805 16.0003C13.8485 16.0003 15.062 16.4134 16.03 17.213C16.9299 17.9193 17.4617 18.9988 17.4753 20.1315V20.1315Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4754 20.1317V23.7965C17.4754 26.0887 15.2938 27.7145 12.6078 27.7145C9.92175 27.7145 7.72656 26.0754 7.72656 23.7965V20.1317C7.91745 17.6796 10.099 15.8272 12.6078 15.9872C13.8758 15.9872 15.0893 16.4003 16.0574 17.1999C16.9436 17.9328 17.4617 18.999 17.4754 20.1317V20.1317Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8145 15.9472V18.6925C32.8145 19.4254 32.201 20.0385 31.451 20.0518H28.7787C27.2925 20.0784 26.0108 18.999 25.8336 17.5597C25.7518 16.7468 26.0517 15.9472 26.6516 15.3875C27.1698 14.8677 27.8788 14.5879 28.615 14.5879H31.451C32.201 14.6012 32.8145 15.2142 32.8145 15.9472V15.9472Z",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54595 15.3208V12.6555C5.31416 9.3105 7.85021 6.40531 11.2589 6.07215C11.627 6.01884 11.9952 5.99219 12.3633 5.99219H24.6345C24.9754 5.99219 25.3162 6.00551 25.6571 6.05882C29.1067 6.352 31.6836 9.28385 31.4518 12.6555V14.5878H28.6158C27.0615 14.5878 25.8207 15.8405 25.8207 17.3464C25.8207 17.4131 25.8207 17.4797 25.8207 17.5596C25.998 18.9989 27.2796 20.0784 28.7658 20.0517H31.4382V21.9841C31.6564 25.449 28.9431 28.4341 25.398 28.6473C25.139 28.6607 24.8799 28.6607 24.6209 28.6473H21.2122",
    stroke: "#19FB80",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCapitallyEfficient);
export default __webpack_public_path__ + "static/media/Capitally_Efficient.422844a70d49916dff87314d283b63bb.svg";
export { ForwardRef as ReactComponent };